"use client";

import { type ReadonlyURLSearchParams, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export const useUrlDrawer = ({ paramName }: { paramName: string }) => {
  const searchParams = useSearchParams() as ReadonlyURLSearchParams | null;
  const drawerParamValue = searchParams?.get(paramName);

  const isOpen = !!drawerParamValue;

  const openDrawer = useCallback(
    (id: string) => {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set(paramName, id);
      window.history.pushState({}, "", currentUrl.toString());
    },
    [paramName],
  );

  const closeDrawer = useCallback(() => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete(paramName);
    window.history.pushState({}, "", currentUrl.toString());
  }, [paramName]);

  return {
    isOpen,
    openDrawer,
    closeDrawer,
    value: drawerParamValue,
  };
};
